document.addEventListener('DOMContentLoaded', function () {

  /* =========================
     PRELOADER HIDE
  ========================== */
  const loader = document.getElementById('preloader');
  if (loader) {
    loader.style.opacity = '0';
    setTimeout(() => loader.remove(), 500);
  }

  /* =========================
     REMOVE "SHOW MORE" BUTTON
  ========================== */
  document.querySelectorAll('.p-description-show-more').forEach(btn => {
    btn.remove();
  });

  /* =========================
     BACK TO TOP ACCESSIBILITY
  ========================== */
  const backToTop = document.querySelector('button[data-id="geBfGVtaUa"]');
  if (backToTop && !backToTop.getAttribute('aria-label')) {
    backToTop.setAttribute('aria-label', 'Back to top');
  }

  /* =========================
     HERO BANNER RESPONSIVE HEIGHT
  ========================== */
  const hero = document.querySelector('.hero-banner');
  if (hero && !hero.dataset.resized) {
    const resizeHero = () => {
      hero.style.height = hero.offsetWidth * 0.5 + 'px';
      hero.dataset.resized = 'true';
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(resizeHero);
    } else {
      setTimeout(resizeHero, 800);
    }
  }

  /* =========================
     GEM PAGES RE-INIT (DELAYED)
  ========================== */
  const runGemPages = () => {
    try {
      if (typeof window.gp_init_carousel === 'function') {
        window.gp_init_carousel();
      }
      if (typeof window.gp_init_marquee === 'function') {
        window.gp_init_marquee();
      }
    } catch (e) {}
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(runGemPages);
  } else {
    setTimeout(runGemPages, 2000);
  }

  /* =========================
     EMAIL SUPPORT (UX OPTIMIZED)
  ========================== */
  const emailCodes = [
    115, 117, 112, 112, 111, 114, 116, 64,
    98, 117, 121, 115, 113, 117, 97, 114,
    101, 46, 105, 110
  ]; // support@buysquare.in

  const decodeEmail = arr => arr.map(c => String.fromCharCode(c)).join('');

  const openCompose = (to) => {
    const gmailApp = 'googlegmail://co?to=' + encodeURIComponent(to);
    const mailto = 'mailto:' + to;
    const gmailWeb = 'https://mail.google.com/mail/?view=cm&fs=1&to=' + encodeURIComponent(to);
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      const start = Date.now();
      window.location = gmailApp;
      setTimeout(() => {
        if (Date.now() - start < 1500) {
          window.location = mailto;
        }
      }, 1200);
    } else {
      window.open(gmailWeb, '_blank');
    }
  };

  const email = decodeEmail(emailCodes);

  document.querySelectorAll('a').forEach(link => {
    if (link.textContent.trim() === 'Email Support') {
      link.textContent = email;
      link.href = '#';
      link.style.cursor = 'pointer';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openCompose(email);
      });
    }
  });

});
